/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import React from "react";

type LayoutProps = {
  isDarkMode: boolean;
  playerHeight: number;

  headerLeft?: React.ReactNode;
  headerCenter?: React.ReactNode;
  headerRight?: React.ReactNode;

  addressSection?: React.ReactNode;
  paymentSection?: React.ReactNode;

  cartLabel: string;
  itemListSection: React.ReactNode;
  summarySection: React.ReactNode;

  footerSection?: React.ReactNode;
};

export const StreamingLiveCommerceCartLayoutV2: React.FC<LayoutProps> = (
  props
) => {
  const classes = liveCommerceCartDesign({
    isDarkModeEnabled: props.isDarkMode,
    THEOPlayerElementHeight: props.playerHeight,
  });

  return (
    <div css={classes.root}>
      {/* ヘッダー枠 */}
      <div css={classes.header}>
        <div>{props.headerLeft}</div>
        <div>{props.headerCenter}</div>
        <div>{props.headerRight}</div>
      </div>

      {/* 住所・決済枠 */}
      <div
        css={css`
          display: flex;
          flex-direction: column;
          gap: 16px;
        `}
      >
        {props.addressSection}
        {props.paymentSection}
      </div>

      <p css={classes.cartLabel}>{props.cartLabel}</p>

      {/* カートメイン枠 */}
      <div css={classes.cart}>
        <div css={classes.itemList}>{props.itemListSection}</div>

        <div css={classes.paymentAmount}>{props.summarySection}</div>

        {props.footerSection}
      </div>
    </div>
  );
};

type LiveCommerceCartDesignProps = {
  THEOPlayerElementHeight: number;
  isDarkModeEnabled: boolean;
};
const liveCommerceCartDesign = (props: LiveCommerceCartDesignProps) => {
  const textColorInDarkMode = props.isDarkModeEnabled
    ? css`
        color: #fff;
      `
    : null;
  const actionAreaHeight = props.THEOPlayerElementHeight
    ? css`
        height: calc(${props.THEOPlayerElementHeight}px - 90px);
      `
    : null;

  const root = css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    @media screen and (min-width: 768px) {
      position: relative;
      padding: 0 10px;
    }
    overflow-y: auto;
  `;
  const darkHeaderColor = css`
    background-color: #333333;
    color: #fff;
  `;
  const lightHeaderColor = css`
    background-color: #f5f5f5;
    color: #333333;
  `;
  const headerBase = css`
    position: sticky;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    padding: 12px 16px;
    border-radius: 8px;
    p {
      padding: 0 12px;
      font-size: 14px;
      font-weight: bold;
    }
  `;
  const header = css`
    ${headerBase}
    ${props?.isDarkModeEnabled ? darkHeaderColor : lightHeaderColor}
  `;
  const cartLabel = css`
    margin-bottom: 8px;
    ${textColorInDarkMode}
    font-size: 18px;
  `;
  const cart = css`
    @media screen and (min-width: 768px) {
      ${actionAreaHeight}
      min-height: 509px;
    }
  `;
  // const categoryHeader = css`
  //   padding: 8px 0;
  //   border-bottom: 1px solid #e0e0e0;
  //   background-color: #f4f4f4;
  //   p{
  //     padding: 0 12px;
  //     font-size: 15px;
  //     font-weight: bold;
  //   }
  // `
  const itemList = css`
    padding: 16px;
    background-color: ${props?.isDarkModeEnabled ? "#333333" : "#f5f5f5"};
    p {
      ${textColorInDarkMode}
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 12px;
    }
  `;

  const size = css`
    margin-bottom: 10px;
    color: #b1b1b1;
    font-size: 14px;
  `;
  const paymentAmount = css`
    padding: 16px 0;
    margin-bottom: 16px;
  `;
  return {
    root,
    header,
    cartLabel,
    cart,
    itemList,
    size,
    paymentAmount,
  };
};

export default StreamingLiveCommerceCartLayoutV2;
